/**
 * @file reducers/Content/reducer.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import { app_reset } from "../App/reducer";

export const initialContentState = () => {
    return {
        list: [],
        section: "",
        status: "",
        contentType: "",
        hasNextPage: false,
    };
};

export const DEFAULT_CONTENT_PAYLOAD = {
    contentList: null,
    pageValue: 1,
    section: "",
    contentType: "",
    timestamp: "",
    status: "",
    pubQueueVersion: "",
    isLoadMore: false,
    contentPackage: null,
};

const contentSlice = createSlice({
    name: "content",
    initialState: initialContentState(),
    reducers: {
        receive_content: {
            reducer: (state, action) => {
                if (action.payload.contentList instanceof Array) {
                    return {
                        ...state,
                        list: action.payload.contentList,
                        pageValue: action.payload.pageValue,
                        hasNextPage: action.payload.hasNextPage,
                        section: action.payload.section,
                        contentType: action.payload.contentType,
                        timestamp: action.payload.timestamp,
                        status: action.payload.status,
                        pubQueueVersion: action.payload.pubQueueVersion,
                        contentPackage: !action.payload.isLoadMore
                            ? action.payload.contentPackage
                            : state.contentPackage,
                    };
                }
            },
            prepare: (payload) => {
                return {
                    payload: {
                        ...DEFAULT_CONTENT_PAYLOAD,
                        ...payload,
                    },
                };
            },
        },
    },
    extraReducers: (builder) => {
        builder.addCase(app_reset, () => {
            return initialContentState();
        });
    },
});

export const { receive_content } = contentSlice.actions;

export default contentSlice.reducer;
